import { render, staticRenderFns } from "./KYCForm.vue?vue&type=template&id=b5b297a6&scoped=true"
import script from "./KYCForm.vue?vue&type=script&lang=js"
export * from "./KYCForm.vue?vue&type=script&lang=js"
import style0 from "./KYCForm.vue?vue&type=style&index=0&id=b5b297a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b297a6",
  null
  
)

export default component.exports